import routesMeta from "./routesMeta.json";

/**
 * Retourne toutes les routes front-end qui ont un id et un name définis.
 * Source de vérité : src/app/routesMeta.json
 * Fichier HTTP exposé : public/route-registry.json (généré via npm run generate:routes)
 * @returns {{ id: string, name: string, path: string }[]}
 */
export function getNamedRoutes() {
  return routesMeta;
}

export default getNamedRoutes;
